import { Typography } from "@mui/material";

export const H3Component = ({ text }: { text: string }) => {
  return (
    <Typography
      component="h4"
      sx={{
        color: "#005EAB",
        fontSize: "18px",
        fontWeight: 600,
        lineHeight: "22px",
      }}
    >
      {text}
    </Typography>
  );
};
